import './index.css';

export default {
  name: 'Asquare',
  props: {
    width: { type: String, default: () => '100%' },
  },
  render() {
    return (
      <div class="a-square" style={{ width: this.width }}>
        <div class="null" />
        <div class="main">{this.$slots.default}</div>
      </div>
    );
  }
}